<template>
  <v-snackbar v-model="snackbar" :color="color" :timeout="timeout" bottom>
    <v-simple-table :class="color">
      <tr>
        <td>{{ text }}</td>
        <td style='width:10%'>
           <v-btn outlined class="text-right ml-4" text @click="snackbar=false">Close</v-btn>
        </td>
      </tr>
    </v-simple-table>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    value: Boolean,
    text: String,
    color: {type: String, default:"info" }
  },

  data() {
    return {
     buttonColor: this.$vuetify.theme.themes['dark'].themeColorA
    }
  },
  
  computed: {
    snackbar: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    },
    timeout() {
      if (this.color === 'error') {
        return 0;
      } else {
        return 2000;
      }
    }
  }
}
</script>